export const blurCurrentInput = () => {
  const activeTextarea = document.activeElement;
  if (activeTextarea instanceof HTMLElement) {
    activeTextarea?.blur();
  }
};
